/**
 * Convert plain-text URLs in HTML to clickable links.
 * Splits on all HTML tags so URLs inside attributes are never touched.
 */
export function linkifyHtml(html: string): string {
  const parts = html.split(/(<[^>]*>)/g);
  return parts
    .map((part) => {
      // Skip HTML tags — only process text nodes
      if (part.startsWith("<")) return part;
      return part.replace(/https?:\/\/[^\s<>"']+/g, (url) => {
        // Strip trailing punctuation likely to be sentence-ending
        const trimmed = url.replace(/[.,;:!?)]+$/, "");
        const trailing = url.slice(trimmed.length);
        return `<a href="${trimmed}" target="_blank" rel="noopener noreferrer">${trimmed}</a>${trailing}`;
      });
    })
    .join("");
}
